import CriarUsuario from '../../Usuarios/CriarUsuario';

// "Novo Cliente": o formulário de criar cambista, gravando tipo_usuario = cliente.
export default function ClienteCriar(props) {
    return <CriarUsuario {...props} nivel="operador" tipo="cliente" />;
}
